// PageDescription: 비대면진료 의사 목록 페이지
import TelemedicineDoctorsTemplate from '@/components/templates/telemedicine/doctor/TelemedicineDoctorsTemplate';
import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import useSearchDoctorsByUser from '@/hooks/telemedicine/useSearchDoctorsByUser';
import useTelemedicineDoctorsViewModel from '@/hooks/telemedicine/useTelemedicineDoctorsViewModel';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const TelemedicineDoctorsPage = ({ client }: CustomPageProps) => {
  const viewModel = useTelemedicineDoctorsViewModel();
  return (
    <>
      <NextSeo
        title={viewModel.category.getSeoTitle()}
        description={viewModel.category.getSeoDescription()}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: viewModel.category.getKeywords(),
          },
        ]}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.DOCTORS.path}${addQueryString(viewModel.queries)}`,
        }}
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.DOCTORS.path}${addQueryString(viewModel.queries)}`}
      />
      <TelemedicineDoctorsTemplate viewModel={viewModel} client={client} />
    </>
  );
};

export default TelemedicineDoctorsPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context;
  const queryClient = new QueryClient();
  const type = query?.type as ECategoryType;
  const id = query?.id as string;
  const page = (query?.page as string) || '1';

  if (!type || !id) {
    return {
      redirect: {
        destination:
          ROUTES.TELEMEDICINE.DOCTORS.path +
          addQueryString({
            type: ECategoryType.Treatment,
            id: '1',
            page,
          }),
        permanent: true,
      },
    };
  }

  await Promise.allSettled([
    useGetDiagnosisCategories.prefetchQuery(queryClient),
    useSearchDoctorsByUser.prefetchQuery(queryClient, type, id, Number(page)),
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
